import { Component, EventEmitter, Input, Output, DoCheck } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { ICCService } from '../icc.service';

@Component({
  selector: 'edit-network',
  styles: [require('../icc.scss')],
  template: require('./edit-network.html'),
    providers: [
      TranslateService
  ]
})
export class EditNetwork {
    @Input() showEditNetworkDialog: boolean = false;
    @Input() selectedResourceDetails: any;
    @Output() dialogStatusChange: EventEmitter<any> = new EventEmitter();

    private isTranslationready: boolean = true;
    private backingList: Array<Object>;
    private isLoading: boolean = false;
    private isDataReady: boolean = false;
    private fleetConfig: any;
    private network: any;
    private dataModel: any;
    private showForm: boolean = false;
    private isFormValid: boolean = true;
    private ipRangeText: string = '';
    private isIPAddressValid: boolean = true;
 constructor(private translate: TranslateService,  public service: ICCService,) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
      this.isDataReady = false;
  }


  ngOnChanges() {
      if (this.selectedResourceDetails) {
            // this.getNetworkBackings(this.selectedResourceDetails.resourceId)
            this.fleetConfig = this.selectedResourceDetails.fleetConfig;
            this.dataModel =  this.selectedResourceDetails.networkDetails;
            this.dataModel.networkName = this.selectedResourceDetails.networkName;
            this.showForm = true;
            this.ipRangeText = this.dataModel.ipPool.startAddress + ' - ' + this.dataModel.ipPool.endAddress;
            this.isIPAddressValid = true;
      }
  }

  checkFormValid(start_address, end_address ) {
    setTimeout(() => {
      this.isFormValid = start_address.valid && end_address.valid;
    }, 0);
  }

  onEditNetworkDialogCancel() {
    this.showEditNetworkDialog = false;
    this.dialogStatusChange.emit();
  }
  onEditNetworkDialogSave() {

  }
  saveNetworkIPRange() {

  }
//   getNetworkBackings(resourceId) {
//     this.backingList = [];
//     this.service.getNetworkBackings(resourceId)
//         .subscribe(
//             data => {
//                 this.backingList = data;
//                 this.isDataReady = true;
//             },
//             error => {
//                 console.log ("Error backing")
//                 this.isLoading = false;
//                 this.isDataReady = false;
//             }
//         );
// }


}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/dialog/edit-network.component.ts